import { Action } from '@ngrx/store';

export enum RecentActivityActionTypes {
  SelectRecentActivity = '[RecentActivity] Select Recent Activity',
  SearchDossiersByRecentActivity = '[RecentActivity] Search Dossiers By Recent Activity'
}

export class SelectRecentActivity implements Action {
  readonly type = RecentActivityActionTypes.SelectRecentActivity;
}

export class SearchDossiersByRecentActivity implements Action {
  readonly type = RecentActivityActionTypes.SearchDossiersByRecentActivity;
}

export type RecentActivityActions = SelectRecentActivity
| SearchDossiersByRecentActivity;
